import { Term } from '@/types/models'
import { isGlobal } from '@/domain/term'

type PageViewProperties = {
  country?: string
  continent?: string
  title?: string
  search: string
  template: string
  term?: string
  term_id?: number
}
interface GeneratePageViewProperties {
  (props: { term: Term }): PageViewProperties
}

const generatePageViewPropertiesForTerm: GeneratePageViewProperties = ({
  term
}) => {
  const defaultProperties: PageViewProperties = {
    search: window.location.search,
    template: term.type,
    title: document.title,
    term: term.title,
    term_id: term.id
  }

  if (isGlobal(term)) {
    return {
      ...defaultProperties,
      continent: 'Global'
    }
  }

  return {
    ...defaultProperties,
    country: 'United States'
  }
}

export default generatePageViewPropertiesForTerm
